import "./parts_creative.css";
import { Fragment, useCallback, useEffect, useRef, useState } from "react";
import { Part } from "./components/part";
import SwiperCore, { Autoplay, EffectFade, Navigation, Pagination } from "swiper";
import PartSearch from "./components/partSearch";
import Breadcrumb from "../../components/__simple/breadcrumb";
import axios from "axios";
import { useTranslation } from "react-i18next";
import { useLocation, useHistory } from "react-router";
import { CheckInput } from "../../components/_input/_checkInput";
import config from "../../configuration/config";
import i18n from "i18next";
import { getData, User_Data_Key } from "../../utils/localStorageManager";
import PaginationComponent from "./paginationComponent";
import CustomaAlert from "./customaAlert";
import { InputField } from "../../components/_input/_input";
import { SparepartsCategoryBox } from "../../components/sparepartsCategoryBox";
import { Swiper, SwiperSlide } from "swiper/react";
import { debounce } from "lodash";
import { AddNewCarPopup, ModelFilterPopup, PartsSearchSelectedCar } from "./VehicleModelFilter";
import AntdPriceSlider from "./components/AntdPriceSlider";
import * as partsService from "../../services//partsService";
SwiperCore.use([Pagination, Navigation, Autoplay, EffectFade]);

// دالة مساعدة لتحويل query string إلى كائن
const getQueryParams = (search) => {
  const params = new URLSearchParams(search);
  return {
    brand: params.get("brand") || "",
    group: params.get("group") || "",
    type: params.get("type") || "",
    yearFrom: params.get("yearFrom") || "",
    yearTo: params.get("yearTo") || "",
    modelCode: params.get("modelCode") || "",
    carProductNo: params.get("carProductNo") || "",
    freeText: params.get("freeText") || "",
    cat: params.get("cat") || "",
    subCat: params.get("subCat") || "",
    subSubCat: params.get("subSubCat") || "",
    isStock: params.get("isStock") === "true" || false,
    pageNumber: parseInt(params.get("pageNumber")) || 1,
    pageSize: parseInt(params.get("pageSize")) || 12,
    sortBy: params.get("SortBy") || "StockTotalQty",
    sortDir: params.get("sortDir") || "DESC",
  };
};
// دالة لمنع السكروول مؤقتًا أثناء تحميل البيانات
let scrollPosition = 0;

export function disableScroll() {
  // حفظ موقع السكروول الحالي
  scrollPosition = window.pageYOffset || document.documentElement.scrollTop;

  // منع السكروول
  document.body.style.overflow = "hidden";
  document.body.style.position = "fixed";
  document.body.style.top = `-${scrollPosition}px`;
  document.body.style.width = "100%";
}

// دالة لإعادة السكروول بعد انتهاء التحميل
export function enableScroll() {
  document.body.style.overflow = "";
  document.body.style.position = "";
  document.body.style.top = "";
  document.body.style.width = "";

  // إعادة موقع السكروول السابق
  window.scrollTo(0, scrollPosition);
}
export function ResulteSearch() {
  const { t: trans } = useTranslation(["common", "eparts", "inputs", "info", "model"]);
  const SECTION_KEY = "Sections_Key";

  const fetchPartsDebounced = useRef(null);
  const location = useLocation();
  const history = useHistory();
  const [Brands, setBrands] = useState([]);
  const [engineGroupsSup2, setEngineGroupsSup2] = useState([]);
  const [sections, setSections] = useState([]);

  const [dataRing, setDataRing] = useState({
    main: 0.1,
    max: 10000,
    minDistanceProp: 100,
    defaultValueProp: [1, 1000000],
  });

  const [valueRing, setValueRing] = useState({
    start: 0.1,
    end: 1000000,
  });
  // const [valueRing, setValueRing] = useState();
  const [filterMain, setFilterMain] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [itemsCountPer, setItemsCountPer] = useState(8);
  const [clearFilter, setClearFilter] = useState(false);
  const [filters, setFilters] = useState(getQueryParams(location.search));
  const [activePage, setActivePage] = useState(1);
  // دالة لجلب البيانات
  useEffect(() => {
    fetchPartsDebounced.current = debounce(async (filters) => {
      setIsLoading(true);

      try {
        const response = await partsService.fetchCompatibleParts(filters);

        if (response.data.items?.length > 0) {
          setItems(response.data.items);
          setCountRow(response.data.items[0].TotalCount ?? 0);
        } else {
          setItems([]);
          setCountRow(0);
        }
      } catch (e) {
        console.error(e);
      } finally {
        setIsLoading(false);
      }
    }, 500);

    return () => {
      fetchPartsDebounced.current?.cancel();
    };
  }, []);
  // أي تغيير في location.search => تحديث الفلاتر وجلب النتائج
  useEffect(() => {
    const newFilters = getQueryParams(location.search);
    setFilters(newFilters);
    const pageNumber = newFilters?.pageNumber ? newFilters?.pageNumber : 1;
    console.log("newFilters>>>>>>>>>>>>>>:", pageNumber);
    setActivePage(pageNumber);
    fetchPartsDebounced.current(newFilters);
  }, [location.search]);
  // أي تغيير في الفلتر => تحديث الـ URL
  const handleFilterChange = (key, value) => {
    // منع السكروول مؤقتًا
    disableScroll();

    // نبدأ بالباراميترات الحالية في الرابط
    const params = new URLSearchParams(history.location.search);
    console.log("key:", key);
    console.log("value:", value);
    console.log("handleFilterChange:", params);
    // إذا كان التغيير ليس pageNumber نعيد الصفحة إلى 1
    if (key !== "pageNumber") {
      params.set("pageNumber", 1);
    }

    // تحديث الفلتر المطلوب
    // if (value === "" || value === false || value == null) {
    //   params.delete(key); // حذف الفلتر فقط
    // } else {
    //   params.set(key, value);
    // }

    value ? params.set(key, value) : params.delete(key);

    history.push({ search: params.toString() });

    // بعد التحديث، يمكنك إعادة السكروول
    // هذا إذا كنت تريد السماح بالسكروول بعد انتهاء تغيير الفلتر
    enableScroll();
  };

  const [showModelFilter, setShowModelFilter] = useState(false);
  const [showAddCar, setShowAddCar] = useState(false);
  const [selectedCar, setSelectedCar] = useState(null);

  //const { value : fav } = useContext(UserFavoriteContext);
  const [allCategories, setAllCategories] = useState(false);
  const [Product, setPro] = useState(null);

  const [lang, setlang] = useState(localStorage.getItem("i18nextLng"));
  const languageDir = "language-" + lang;

  const [countRow, setCountRow] = useState(0);
  const [isStock, setIsStock] = useState(false);

  let query = new URLSearchParams(useLocation().search);

  const [engineGroupsObject, setEngineGroupsObject] = useState({
    EngineGroups: [],
    EngineGroupsSup: [],
    EngineGroupsSup2: [],
  });
  useEffect(() => {
    if (query) {
      setPro(query.has("freeText") ? query.get("freeText") : undefined);
      setAllCategories(query.has("allCategories"));
    }
  }, [query]);

  const [nameCat, setNameCat] = useState({
    catAr: "",
    catEn: "",
    subCatAr: "",
    subCatEn: "",
    subSubCatAr: "",
    subSubCatEn: "",
  });

  const [queryProduct, setQueryProduct] = useState(query.get("freeText") ?? null);

  function SendRequset() {
    const BodyEngineGroups = {
      Option: "Column",
      Fields: "GroupIDMain,DescriptionAr,DescriptionEn,GUID",
      ObjectSettings: {
        MetaData: false,
      },
    };
    const requestEngineGroups = axios.request({
      url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_categorySP`,
      data: BodyEngineGroups,
      method: "POST",
      responseType: "json",
    });

    const BodyEngineGroupsSUP = {
      ObjectSettings: {
        MetaData: false,
      },
    };
    const requestEngineGroupsSUP = axios.request({
      url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_SupCategory`,
      data: BodyEngineGroupsSUP,
      method: "POST",
      responseType: "json",
    });

    const BodyEngineGroupsSUP2 = {
      ObjectSettings: {
        MetaData: false,
      },
    };
    const requestEngineGroupsSUP2 = axios.request({
      url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/DetailsSite_ItemsSupCategory`,
      data: BodyEngineGroupsSUP2,
      method: "POST",
      responseType: "json",
    });

    axios
      .all([requestEngineGroups, requestEngineGroupsSUP, requestEngineGroupsSUP2])
      .then(
        axios.spread(function (EngineGroups, EngineGroupsSup, EngineGroupsSup2) {
          handleBuildCategoriesSections(EngineGroups?.data?.ApiObjectData);
          setTimeout(() => {
            setEngineGroupsSup2(engineGroupsSup2?.data?.ApiObjectData);
          }, 1500);
        })
      )
      .catch(function (error) {
        //console.log(error);
      });
  }

  // to build the categories dynamically and store data into the storage
  //----------------------------------------------------
  const handleBuildCategoriesSections = (data) => {
    let sectionsList = [];
    if (data && data?.length > 0) {
      sectionsList = data.map((item) => {
        return {
          id: item.GroupIDMain,
          descriptionAr: item.DescriptionAr,
          descriptionEn: item.DescriptionEn,
          activ: true,
        };
      });
    }
    localStorage.setItem(SECTION_KEY, JSON.stringify(sectionsList));
    setSections(sectionsList);
  };
  //----------------------------------------------------
  const [SearchItems, setItems] = useState([]);
  const [searchItemsPagination, setSearchItemsPagination] = useState([]);
  const [CheckedBrand, setCheckedBrand] = useState([]);

  const [checkedCateegores, setCheckedCateegores] = useState([]);
  const OnCheckCate = (event) => {
    const { id, checked } = event;
    var currentlistvalues = (prevCheckedBrands) => {
      if (checked) {
        // Add the brand ID to the array if checked
        return [...prevCheckedBrands, id];
      } else {
        // Remove the brand ID from the array if unchecked
        return prevCheckedBrands.filter((brandId) => brandId !== id);
      }
    };

    const listValues = currentlistvalues(checkedCateegores);

    setCheckedCateegores(listValues);
    //-----------------

    const listValuesString = listValues?.join(",");

    handleFilterChange("cat", listValuesString);
  };

  useEffect(() => {
    SendRequset();
  }, []);

  // -------------------------------------------------
  const [favoriteProducts, setFavoriteProducts] = useState([]);
  // to fetch the user favorites
  const fetchUserFavorites = async () => {
    let _favorites = [];
    try {
      const isLogin = getData("isAuthenticated");
      if (isLogin) {
        const { id } = JSON.parse(getData(User_Data_Key, true));
        const userID = Number(id.toString().split("_")[1]);
        const response = await axios.post(`${config.controllURL}${i18n.language || 'ar'}/api/Pages/SiteFetchUserFavorites`, {
          userID: userID,
        });
        if (response.status == 200) {
          const favorites = response.data;
          _favorites = _favorites.concat(favorites);
        }
      }
    } catch (err) {
      //console.log(err);
    }
    return _favorites;
  };
  useEffect(async () => {
    const results = await fetchUserFavorites();
    setFavoriteProducts(results);
  }, []);

  useEffect(() => {
    // setIsLoading(false);

    setSearchItemsPagination([]);
    if (SearchItems && SearchItems.length > 0) {
      var index = 0;
      var endIndex = 0;

      endIndex = activePage * itemsCountPer - 1;

      index = endIndex - itemsCountPer + 1;

      //console.log(`index:  ${index}`);
      //console.log(`endIndex:  ${endIndex}`);

      var pagValue = SearchItems.slice(index, endIndex + 1).map((val) => {
        return val;
      });

      //console.log(`pagValue:`, pagValue);

      setSearchItemsPagination(pagValue);
    }
  }, [SearchItems]);

  const clearFilters = useRef(null);

  const getNameCat = async ({ reqCat, reqSubCat, reqSubSubCat }) => {
    try {
      const body = {
        cat: Number(reqCat),
        subCat: Number(reqSubCat),
        subSubCat: Number(reqSubSubCat),
      };

      await axios
        .request({
          url: `${config.controllURL}${i18n.language || 'ar'}/api/Pages/func_GetNameCatsByIdEPart`,
          data: body,
          method: "POST",
          responseType: "json",
        })
        .then(function (response) {
          if (response.data && response.data.length > 0) {
            console.info("func_GetNameCatsByIdEPart:data", response.data[0]);
            setNameCat(response?.data[0]);
          }
        })
        .catch(function (error) {
          // console.warn("func_GetNameCatsByIdEPart:catch", error);
          throw error;
        });
    } catch (ex) {
      console.warn("func_GetNameCatsByIdEPart:catch", ex);
    }
  };

  useEffect(() => {
    console.info("subSubCat : ", filters?.subSubCat);
    if (filters?.cat || filters?.subCat || filters?.subSubCat || allCategories) {
      getNameCat({ reqCat: filters?.cat, reqSubCat: filters?.subCat, reqSubSubCat: filters?.subSubCat });
    }
  }, [filters?.cat, filters?.subCat, filters?.subSubCat, allCategories]);

  // useEffect(() => {
  //   if (allCategories) {

  //     getResultVehicleByCat();
  //     setNameCat({});
  //   }
  // }, [allCategories]);

  // useEffect(() => {
  //     // if (isStock){
  //     // getEPartsWithStock();
  //     // }
  // }, [isStock]);
  const resultNameCat = ({ objCat }) => {
    if (objCat.catAr && objCat.catEn) {
      if (objCat.catAr && objCat.catEn && objCat.subCatAr && objCat.subCatEn) {
        if (objCat.catAr && objCat.catEn && objCat.subCatAr && objCat.subCatEn && objCat.subSubCatAr && objCat.subSubCatEn) {
          return (
            <>
              <label className="flex flex-wrap gap-1">
                <span className="bg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-cente">{lang.toLowerCase() == "ar" ? objCat.catAr : objCat.catEn}</span>
                <span className="bg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-cente">{lang.toLowerCase() == "ar" ? objCat.subCatAr : objCat.subCatEn}</span>
                <span className="bg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-cente">
                  {lang.toLowerCase() == "ar" ? objCat.subSubCatAr : objCat.subSubCatEn}
                </span>
              </label>
            </>
          );
        } else {
          return (
            <>
              <div className="flex flex-wrap gap-1">
                <span className="bg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">{lang.toLowerCase() == "ar" ? objCat.catAr : objCat.catEn}</span>
                <span className="bg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">
                  {lang.toLowerCase() == "ar" ? objCat.subCatAr : objCat.subCatEn}
                </span>
              </div>
            </>
          );
        }
      } else {
        return (
          <label className="flex flex-wrap gap-1">
            <span className="tbg-white px-5 py-2 rounded-full text-2xl text-gray-700 border border-gray-300 flex items-center">{lang.toLowerCase() == "ar" ? objCat.catAr : objCat.catEn}</span>
          </label>
        );
      }
    } else {
      return <></>;
    }
  };

  const handleSelectModel = (car) => {
    setSelectedCar(car);

    if (car) {
      localStorage.setItem("user_local_selectedCar", JSON.stringify(car));

      console.log("handleSelectModel:", car);
      const modelCode = car?.modelCode;
      const year = car?.year;

      handleFilterChange("modelCode", modelCode);
      handleFilterChange("yearFrom", year);
      handleFilterChange("yearTo", year);
    } else {
      localStorage.removeItem("user_local_selectedCar");

      handleFilterChange("modelCode", null);
      handleFilterChange("yearFrom", null);
      handleFilterChange("yearTo", null);
    }
  };

  const [selectedVehicle, setSelectedVehicle] = useState(null);
  const [localCars, setLocalCars] = useState([]);

  // تحميل السيارات المحفوظة محلياً
  useEffect(() => {
    const existingCars = JSON.parse(localStorage.getItem("user_local_cars") || "[]");
    if (existingCars) {
      setLocalCars(existingCars);
    }
    const selCarStr = localStorage.getItem("user_local_selectedCar");

    if (selCarStr) {
      const selCar = JSON.parse(selCarStr); // ✅ مهم جدًا
      const carExists = existingCars.find((existingCar) => existingCar.id === selCar?.id);
      if (carExists) handleSelectModel(selCar);
      else {
        handleSelectModel(null);
      }
    }
  }, []);

  const handleSaveCar = (car) => {
    console.log("تم حفظ السيارة:", car);
    setSelectedVehicle(car);
    setTimeout(() => setShowModelFilter(true), 300);
    if (car.id.startsWith("local_")) {
      // حفظ في localStorage للسيارات المحلية
      const existingCars = JSON.parse(localStorage.getItem("user_local_cars") || "[]");
      const carExists = existingCars.some((existingCar) => existingCar.id === car.id);

      if (!carExists) {
        const updatedCars = [...existingCars, car];
        localStorage.setItem("user_local_cars", JSON.stringify(updatedCars));
        setLocalCars(updatedCars);
      }
    } else {
      // سيارة من قاعدة البيانات - إضافتها إلى القائمة المحلية أيضاً
      const existingCars = JSON.parse(localStorage.getItem("user_local_cars") || "[]");
      const carExists = existingCars.some((existingCar) => existingCar.id === car.id);

      if (!carExists) {
        const updatedCars = [...existingCars, car];
        localStorage.setItem("user_local_cars", JSON.stringify(updatedCars));
        setLocalCars(updatedCars);
      }
    }
  };
  return (
    <Fragment>
      {/* ── Premium Search Header ── */}
      <div style={{
        background: '#fff',
        borderBottom: '2px solid #e5e7eb',
        boxShadow: '0 2px 16px rgba(0,0,0,.07)',
        position: 'sticky',
        top: 0,
        zIndex: 100,
      }}>
        <div className="container" style={{ paddingTop: 14, paddingBottom: 14 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, flexWrap: 'wrap' }}>

            {/* All Categories pill */}
            <a
              href={"/parts/sereach?allCategories=true"}
              style={{
                flexShrink: 0,
                background: '#eb0a1e',
                color: '#fff',
                padding: '11px 22px',
                borderRadius: 40,
                fontWeight: 700,
                fontSize: '.95rem',
                textDecoration: 'none',
                whiteSpace: 'nowrap',
                transition: 'background .25s',
              }}
              onMouseEnter={e => e.currentTarget.style.background = '#1a1a1a'}
              onMouseLeave={e => e.currentTarget.style.background = '#eb0a1e'}
            >
              {lang.toLowerCase() === "ar" ? "جميع الفئات" : "All Categories"}
            </a>

            {/* Search input */}
            <div style={{
              flex: 1,
              minWidth: 200,
              background: '#f3f4f6',
              borderRadius: 40,
              display: 'flex',
              alignItems: 'center',
              padding: '4px 8px',
              border: '1.5px solid transparent',
              transition: 'border-color .25s',
            }}
              onFocus={e => e.currentTarget.style.borderColor = '#eb0a1e'}
              onBlur={e => e.currentTarget.style.borderColor = 'transparent'}
            >
              <InputField
                searchIcon={true}
                extraClasses="part-input-search"
                placeholder={trans("info:name-number-search")}
                onChangeValue={(e) => {
                  setQueryProduct(null);
                  setQueryProduct(e.target.value);
                  handleFilterChange("freeText", e.target.value);
                }}
                onClicksearchIcon={() => handleFilterChange("freeText", queryProduct)}
                value={queryProduct}
              />
            </div>

            {/* Car model filter button */}
            <button
              onClick={() => setShowModelFilter(true)}
              style={{
                flexShrink: 0,
                display: 'flex',
                alignItems: 'center',
                gap: 8,
                padding: '10px 20px',
                borderRadius: 40,
                border: selectedCar ? '1.5px solid #22c55e' : '1.5px solid #d1d5db',
                background: '#fff',
                color: selectedCar ? '#16a34a' : '#374151',
                fontWeight: 700,
                fontSize: '.92rem',
                cursor: 'pointer',
                transition: 'all .25s',
                whiteSpace: 'nowrap',
              }}
            >
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="20px" height="20px" fill="none">
                <path d="M24,13H4l2-4.6C6.6,7,8,6,9.6,6h8.7c1.6,0,3,1,3.7,2.4L24,13z" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M8,23H2v2c0,1.1,0.9,2,2,2h2c1.1,0,2-0.9,2-2V23z" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M17,23H3c-1.1,0-2-0.9-2-2v-4c0-2.2,1.8-4,4-4h18c2.1,0,3.8,1.6,4,3.7" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="24" cy="23" r="7" stroke="#22c55e" strokeWidth="2" />
                <line x1="24" y1="20" x2="24" y2="26" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" />
                <line x1="21" y1="23" x2="27" y2="23" stroke="#22c55e" strokeWidth="2" strokeLinecap="round" />
              </svg>
              <span style={{ maxWidth: 160, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
                {selectedCar ? selectedCar.name : (lang.toLowerCase() === 'ar' ? 'تصفية بالموديل' : 'Filter by Model')}
              </span>
            </button>
          </div>
        </div>

        <PartSearch
          isIndex={false}
          onChangValuesProp={(data) => { setFilterMain(data); }}
          isLoadingFuncProp={(val) => {
            setCountRow(val === true ? 0 : countRow);
            setIsLoading(val);
          }}
          ref={clearFilters}
          passEngineGroups={(EngineGroupsObject) => { setEngineGroupsObject(EngineGroupsObject); }}
          activePage={activePage ?? 1}
        />
      </div>
      <div className="container" style={{ paddingTop: 28, paddingBottom: 60 }}>
        {allCategories == true ? (
          <>
            {/* Breadcrumb */}
            <Breadcrumb
              className="mt-16"
              links={[
                { name: trans("eparts:EpartTitel"), to: "/parts" },
                {
                  className: "text-primary",
                  name: lang.toLowerCase() === "ar" ? "الفئات" : "Categories",
                  to: `/parts/sereach?allCategories`,
                },
              ]}
            />
            {/* Section heading */}
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24, marginTop: 8 }}>
              <span style={{
                display: 'inline-block', width: 5, height: 28,
                background: '#eb0a1e', borderRadius: 3, flexShrink: 0,
              }} />
              <span className="text-30" style={{ fontWeight: 800, color: '#1a1a1a' }}>
                {lang.toLowerCase() === "ar" ? "جميع الفئات" : "All Categories"}
              </span>
            </div>

            {engineGroupsObject.EngineGroups?.length > 0 && (
              <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                gap: 16,
                paddingBottom: 16,
              }}>
                {engineGroupsObject.EngineGroups?.map((proValue) => (
                  <SparepartsCategoryBox
                    key={proValue.GroupIDMain}
                    titlebtn={null}
                    link={`/parts/sereach?cat=${proValue?.GroupIDMain}&subCat=null&subSubCat=null`}
                    imgUrl={proValue.ImageUrl}
                    titleEn={proValue.DescriptionEn}
                    titleAr={proValue.DescriptionAr}
                  />
                ))}
              </div>
            )}
          </>
        ) : nameCat?.catAr && nameCat?.catEn ? (
          (() => {
            var linkListObject = [
              {
                name: trans("eparts:EpartTitel"),
                to: "/parts",
              },
              {
                className: !filters?.subCat || filters?.subCat == "null" ? "text-primary" : "",
                name: lang.toLowerCase() == "ar" ? nameCat?.catAr : nameCat?.catEn,
                to: `/parts/sereach?cat=${filters?.cat}&subCat=${null}&subSubCat=${null}`,
              },
            ];

            if (filters?.subCat && filters?.subCat != "null")
              linkListObject.push({
                className: !filters?.subSubCat || filters?.subSubCat == "null" ? "text-primary" : "",
                name: lang.toLowerCase() == "ar" ? nameCat?.subCatAr : nameCat?.subCatEn,
                to: `/parts/sereach?cat=${filters?.cat}&subCat=${filters?.subCat}&subSubCat=${null}`,
              });

            if (filters?.subSubCat && filters?.subSubCat != "null")
              linkListObject.push({
                className: "text-primary",
                name: lang.toLowerCase() == "ar" ? nameCat?.subSubCatAr : nameCat?.subSubCatEn,
                to: `/parts/sereach?cat=${filters?.cat}&subCat=${filters?.subCat}&subSubCat=${filters?.subSubCat}`,
              });

            var thisEngineGroupsSup = [];
            var SparepartsCategoryBoxSlid = [];
            if ((!filters?.subCat || filters?.subCat == "null") && filters?.cat) {
              if (engineGroupsObject.EngineGroupsSup?.length > 0) {
                thisEngineGroupsSup = engineGroupsObject.EngineGroupsSup?.filter((g) => g.GroupIDMain == filters?.cat);

                SparepartsCategoryBoxSlid = thisEngineGroupsSup?.map((proValue, prodIndex) => (
                  <SwiperSlide className={"px-3"} key={proValue.GroupIDMainSup1}>
                    <SparepartsCategoryBox
                      titlebtn={null}
                      link={`/parts/sereach?cat=${filters?.cat}&subCat=${proValue?.GroupIDMainSup1}&subSubCat=null`}
                      imgUrl={proValue.ImageUrl}
                      titleEn={proValue.DescriptionEn}
                      titleAr={proValue.DescriptionAr}
                    />
                  </SwiperSlide>
                ));
              }
            } else if ((!filters?.subSubCat || filters?.subSubCat == "null") && filters?.subCat) {
              if (engineGroupsObject.EngineGroupsSup2?.length > 0) {
                thisEngineGroupsSup = engineGroupsObject.EngineGroupsSup2?.filter((g) => g.GroupIDMainSup1 == filters?.subCat);
                SparepartsCategoryBoxSlid = thisEngineGroupsSup?.map((proValue, prodIndex) => (
                  <SwiperSlide className={"px-3"} key={proValue.GroupIDMainSup2}>
                    <SparepartsCategoryBox
                      titlebtn={null}
                      link={`/parts/sereach?cat=${filters?.cat}&subCat=${proValue?.GroupIDMainSup1}&subSubCat=${proValue?.GroupIDMainSup2}`}
                      imgUrl={proValue.ImageUrl}
                      titleEn={proValue.DescriptionEn}
                      titleAr={proValue.DescriptionAr}
                    />
                  </SwiperSlide>
                ));
              }
            }

            return (
              <>
                <Breadcrumb className="mt-16" links={linkListObject} />
                <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24, marginTop: 8 }}>
                  <span style={{
                    display: 'inline-block', width: 5, height: 28,
                    background: '#eb0a1e', borderRadius: 3, flexShrink: 0,
                  }} />
                  <span className="text-30" style={{ fontWeight: 800, color: '#1a1a1a' }}>
                    {linkListObject[linkListObject.length - 1]?.name}
                  </span>
                </div>

                {thisEngineGroupsSup?.length > 0 && (
                  <div style={{
                    display: 'grid',
                    gridTemplateColumns: 'repeat(auto-fill, minmax(160px, 1fr))',
                    gap: 16, paddingBottom: 16,
                  }}>
                    {thisEngineGroupsSup?.map((proValue) => {
                      const isSub2 = filters?.subCat && filters.subCat !== 'null';
                      return (
                        <SparepartsCategoryBox
                          key={isSub2 ? proValue.GroupIDMainSup2 : proValue.GroupIDMainSup1}
                          titlebtn={null}
                          link={
                            isSub2
                              ? `/parts/sereach?cat=${filters?.cat}&subCat=${proValue?.GroupIDMainSup1}&subSubCat=${proValue?.GroupIDMainSup2}`
                              : `/parts/sereach?cat=${filters?.cat}&subCat=${proValue?.GroupIDMainSup1}&subSubCat=null`
                          }
                          imgUrl={proValue.ImageUrl}
                          titleEn={proValue.DescriptionEn}
                          titleAr={proValue.DescriptionAr}
                        />
                      );
                    })}
                  </div>
                )}
              </>
            );
          })()
        ) : (
          <>
            <Breadcrumb
              className="mt-16"
              links={[{ name: trans("eparts:EpartTitel"), to: "/parts" }]}
            />
            {Product && (
              <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: '8px 0 24px' }}>
                <span style={{ display: 'inline-block', width: 5, height: 28, background: '#eb0a1e', borderRadius: 3 }} />
                <span className="text-30" style={{ fontWeight: 800 }}>
                  {lang.toLowerCase() === "ar" ? "نتائج البحث عن: " : "Results for: "}
                  <span style={{ color: '#eb0a1e' }}>{Product}</span>
                </span>
              </div>
            )}
          </>
        )}
      </div>
      {/* عرض السيارة المختارة */}
      <div className="container pt-5 pb-5 ">
        <PartsSearchSelectedCar selectedCarData={selectedCar} onOpenModelFilter={(val) => setShowModelFilter(val)} onSelectedCar={(val) => handleSelectModel(val)} />
      </div>
      <div className={"container " + languageDir}>
        <div className="grid grid-cols-1 lg:grid-cols-4 gap-8 mt-8">
          <div className="lg:col-span-1 space-y-8 mb-8" style={{
            background: '#fff', borderRadius: 14,
            padding: '24px 20px',
            border: '1.5px solid #e5e7eb',
            boxShadow: '0 2px 8px rgba(0,0,0,.06)',
            alignSelf: 'start', position: 'sticky', top: 80,
          }}>
            <div className="helper">
              <div>
                {/*{"البحث بالرنج"}*/}
                <div className="mb-10 w-full">
                  <span className="text-14 text-gray helper-section-heading">{trans("info:price-sar")}</span>

                  <AntdPriceSlider
                    minProp={dataRing.main}
                    maxProp={dataRing.max}
                    minDistanceProp={
                      dataRing.max <= 5000 && dataRing.max >= 1
                        ? dataRing.max * 0.1 - dataRing.main
                        : dataRing.max <= 10000 && dataRing.max > 5000
                          ? dataRing.max * 0.09 - dataRing.main
                          : dataRing.max * 0.1 - dataRing.main
                    }
                    defaultValueProp={dataRing.defaultValueProp}
                    returnProp={(value) => {
                      console.info("console.info:  ", value);
                      setValueRing(value);
                    }}
                    className={"my-price-slider "}
                    isRTL={lang === "ar" ? true : false}
                  />
                </div>

                <div className="helper-section-heading mb-10">
                  {trans("info:category")}
                  {sections.map((B, index) => {
                    if (lang === "en") {
                      return (
                        <CheckInput id={B.id} key={index} className=" cursor-pointer" labelClassName=" nice-flex-row-reverse nice-flex-space-between " oncheng={OnCheckCate} Name={"CH_SEC" + B.id}>
                          <label htmlFor={B.id} className="helper-section-label">
                            {B.descriptionEn}
                          </label>
                        </CheckInput>
                      );
                    } else {
                      return (
                        <CheckInput id={B.id} key={index} className=" cursor-pointer" labelClassName=" nice-flex-row-reverse  nice-flex-space-between " oncheng={OnCheckCate} Name={"CH_SEC" + B.id}>
                          <label htmlFor={B.id} className="helper-section-label">
                            {B.descriptionAr}
                          </label>
                        </CheckInput>
                      );
                    }
                  })}
                </div>

                {
                  <>
                    <hr className="mt-10" />
                    <div className="helper-section-heading my-5">
                      <CheckInput
                        id={"in-stock"}
                        className="text-primary cursor-pointer"
                        labelClassName=" nice-flex-row-reverse  nice-flex-space-between "
                        checked={isStock}
                        oncheng={async (event) => {
                          setIsStock(event.checked);
                          await handleFilterChange("isStock", event.checked);
                        }}
                        Name={"23-44"}>
                        <label htmlFor={"in-stock"} className="text-2xl sm:text-2xl md:text-2xl">
                          {trans("eparts:in-stock")}
                        </label>
                      </CheckInput>
                    </div>
                  </>
                }

                <hr className="mt-10" />
                <div className="helper-section-heading my-5 pb-8 border-b">
                  <a
                    href={"/parts/sereach?allCategories=true"}
                    className="font-bold text-3xl nice-line-underline sm:text-3xl md:text-2xl cursor-pointer hover:text-[#3bd461]"
                    onClick={async (e) => {
                      setNameCat({ catAr: null, catEn: null });
                      setClearFilter(true);
                      setIsStock(false);
                      await handleFilterChange("isStock", false);
                    }}>
                    {trans("info:clear-all-filters")}
                  </a>
                </div>
              </div>
            </div>
          </div>
          <div className="lg:col-span-3 pb-20 mb-5" style={{
            background: '#fff', borderRadius: 14,
            padding: '24px 20px',
            border: '1.5px solid #e5e7eb',
            boxShadow: '0 2px 8px rgba(0,0,0,.06)',
          }}>
            <div className=" grid grid-cols-6 sm:grid-cols-6 md:grid-cols-8 lg:grid-cols-8 xl:grid-cols-8 justify-items-auto mb-5 p-6 border-b border-gray-200">
              <div className="col-span-5 sm:col-span-5 md:col-span-7 lg:col-span-7 xl:col-span-7 justify-center items-center">
                <div className="flex">
                  <div className="flex-auto text-start px-4 py-2 m-2 ">
                    <span className="text-gray-700 text-2xl sm:text-3xl md:text-3xl lg:text-2xl">{resultNameCat({ objCat: nameCat })}</span>
                  </div>
                </div>
              </div>

              <div className="col-span-1 sm:col-span-1 md:col-span-1 lg:col-span-1 xl:col-span-1 justify-center items-center">
                <div className="flex ">
                  <div className="w-px  bg-gray-400"></div>
                  <div className="flex-auto text-end px-2 py-2 m-2 text-end-important">
                    <span className="mx-3 text-3xl sm:text-3xl md:text-3xl lg:text-2xl font-bold ">{countRow.toString()}</span>

                    <span className="mx-3 text-3xl sm:text-3xl md:text-3xl lg:text-2xl font-bold ">{trans("eparts:results")}</span>
                  </div>
                </div>
              </div>
            </div>
            {
              <div className="relative min-h-screen ">
                {isLoading && (
                  <>
                    {/* <div id="SEC_CH_SEC" className="flex justify-center items-center h-full">
                      <div className="text-center py-12">
                        <div className="inline-block animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-green-500 mb-4"></div>
                        <p className={""}>جاري تحميل ...</p>
                      </div>
                    </div> */}
                    <div
                      className="flex justify-center items-center"
                      style={{
                        position: "absolute",
                        inset: 0,
                        backdropFilter: "blur(1.5px)",
                        backgroundColor: "rgba(255, 255, 255, 0.1)",
                        zIndex: 10,
                      }}>
                      <div className="text-center py-12">
                        <div className="inline-block animate-spin rounded-full h-24 w-24 border-t-2 border-b-2 border-green-500 mb-4"></div>
                        <p className={"text-center text-24"}>جاري البحث ...</p>
                      </div>
                    </div>
                  </>
                )}
                {SearchItems.length === 0 ? (
                  <div className="container my-8">
                    <CustomaAlert titleProp={trans("info:title-alert")} textProp={trans("info:text-alert")} />
                  </div>
                ) : (
                  <>
                    <div id="SEC_CH_SEC" className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6" key={"0000"}>
                      {SearchItems?.map((P, index) => {
                        // searchItemsPagination?.map(P => {
                        // if (P.CategorySPID === item.id.toString())

                        if (valueRing && valueRing.start <= P.SalesPrice && valueRing.end >= P.SalesPrice)
                          if (P.SalesPriceDiscount < 0)
                            return (
                              <div
                                key={index}
                                className="group bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 lg:hover:-translate-y-2 border border-gray-100 flex flex-col h-full">
                                <Part
                                  Engine_Groups={P.CategiorAr}
                                  SalesPriceBefor={P.SalesPrice}
                                  GUID={P.GUID}
                                  Weight={P.Weight}
                                  height={P.height}
                                  width={P.width}
                                  length={P.length}
                                  ProductImage={P.ProductImage}
                                  DescriptionEn={P.DescriptionEn}
                                  DescriptionAr={P.DescriptionAr}
                                  NetSalePrice={P.SalesPriceDiscount}
                                  ProductID={P.ProductID}
                                  ProductNo={P.ProductNo}
                                  Qty={P.TotalQty}
                                />
                              </div>
                            );
                          // }
                          else
                            return (
                              <div
                                key={index}
                                className="group bg-white rounded-2xl shadow-xl overflow-hidden hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-1 lg:hover:-translate-y-2 border border-gray-100 flex flex-col h-full">
                                <Part
                                  Engine_Groups={P.CategiorAr}
                                  SalesPriceBefor={P.SalesPriceDiscount}
                                  GUID={P.GUID}
                                  favorites={favoriteProducts}
                                  Weight={P.Weight}
                                  height={P.height}
                                  width={P.width}
                                  length={P.length}
                                  ProductImage={P.ProductImage}
                                  DescriptionEn={P.DescriptionEn}
                                  DescriptionAr={P.DescriptionAr}
                                  NetSalePrice={P.SalesPrice}
                                  ProductID={P.ProductID}
                                  ProductNo={P.ProductNo}
                                  Qty={P.TotalQty}
                                />
                              </div>
                            );
                      })}
                    </div>

                    {SearchItems.length > 0 && countRow > 8 && (
                      <div className="mt-20 mb-6">
                        <PaginationComponent
                          lang={lang}
                          activePageProp={activePage}
                          itemsCountPerPageProp={itemsCountPer} // * totalItemsCountProp/10
                          totalItemsCountProp={countRow}
                          pageRangeDisplayedProp={5} // عدد// الصصفحات// الضاهرو
                          pageReturnProp={(val) => {
                            setActivePage(val);
                            console.log(`active page is ${val}`);
                            handleFilterChange("pageNumber", val);

                            // searchWithPagination(val);

                            //console.log(`active page is ${val}`);
                            //console.log(`SearchItems.length ${SearchItems.length}`);
                          }}
                        />
                      </div>
                    )}
                  </>
                )}
              </div>
            }
          </div>
        </div>
      </div>

      {/* نافذة تصنيف الموديل */}
      <ModelFilterPopup
        isOpen={showModelFilter}
        onClose={() => setShowModelFilter(false)}
        onSelectModel={handleSelectModel}
        onAddNewCar={() => {
          setShowModelFilter(false);
          setTimeout(() => setShowAddCar(true), 300);
        }}
        selectedCarData={selectedCar}
      />

      {/* نافذة إضافة سيارة جديدة */}
      <AddNewCarPopup isOpen={showAddCar} onClose={() => setShowAddCar(false)} onSave={handleSaveCar} />
    </Fragment>
  );
}
